export default function ({ isActive }) {
    return {
        isActive,
        detectCategory() {
            let currentUrl = window.location.href;
            return currentUrl.slice(currentUrl.lastIndexOf('/') + 1);
        },
        isSameCategory(id) {
            return this.detectCategory() === id;
        }
    };
}
